import 'css-chunksrc/client/pages/projectPage/discussionsPage/loader/styles.scss';export default {
  "discussions": "_discussions_joxy3_1",
  "discussion": "_discussion_joxy3_1"
};